import { colors, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { getDefectRequest, getLabourRequest, getMaterialRequest } from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import { addMaterials, resetMaterials } from '../../store/actions/materialActions';
import BulletinControl from './BulletinControl';
import Header from 'src/components/Header';
import ProductDefectControl from './ProductDefectControl';
import ProductControl from './ProductControl';
import HelperControl from './HelperControl';
import ProductWarranty from './ProductWarranty';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(1)
  },
}));


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


function Isler() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  return (
    <Page
      className={classes.root}
      title="Ürün Bilgileri Detayı"
    >
      <Container>
        <Header />
      </Container>
      <Tabs value={value}
        aria-label="simple tabs example"
        textColor="secondary"
        scrollButtons="on"
        indicatorColor="primary"
        variant="scrollable"
        onChange={handleChange}>
        <Tab label="Ürün" />
        <Tab label="Garantİ" />
        <Tab label="Bülten" />
        <Tab label="Kütüphane" />
        <Tab label="Malzeme" />
      </Tabs>
      <TabPanel value={value} index={0}><ProductControl /></TabPanel>
      <TabPanel value={value} index={1}><ProductWarranty /></TabPanel>
      <TabPanel value={value} index={2}><BulletinControl /></TabPanel>
      <TabPanel value={value} index={3}><HelperControl /></TabPanel>
      <TabPanel value={value} index={4}><ProductDefectControl /></TabPanel>

    </Page>
  );
}

Isler.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  { resetDefects, resetLabours, resetMaterials, addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest }
)(Isler);
